module.exports = __webpack_public_path__ + "img/VetoSans-Italic.5707bc74.svg";